var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12.8301V16.5301C18.5 19.6501 15.59 22.1801 12 22.1801C8.41 22.1801 5.5 19.6501 5.5 16.5301V12.8301C5.5 15.9501 8.41 18.1801 12 18.1801C15.59 18.1801 18.5 15.9501 18.5 12.8301Z",
    stroke: "#234943",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7.83018C18.5 8.74018 18.25 9.58017 17.81 10.3002C16.74 12.0602 14.54 13.1802 12 13.1802C9.46 13.1802 7.26 12.0602 6.19 10.3002C5.75 9.58017 5.5 8.74018 5.5 7.83018C5.5 6.27018 6.22999 4.86018 7.39999 3.84018C8.57999 2.81018 10.2 2.18018 12 2.18018C13.8 2.18018 15.42 2.81018 16.6 3.83018C17.77 4.86018 18.5 6.27018 18.5 7.83018Z",
    stroke: "#234943",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7.83018V12.8302C18.5 15.9502 15.59 18.1802 12 18.1802C8.41 18.1802 5.5 15.9502 5.5 12.8302V7.83018C5.5 4.71018 8.41 2.18018 12 2.18018C13.8 2.18018 15.42 2.81018 16.6 3.83018C17.77 4.86018 18.5 6.27018 18.5 7.83018Z",
    stroke: "#234943",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashback);
export default __webpack_public_path__ + "static/media/cashback.069d0da6f5baa69b537bdde43e89474a.svg";
export { ForwardRef as ReactComponent };